export default __webpack_public_path__ + "static/media/company_logo.812c6745.svg";